import {
  FlatFileObjectConfigFormReducerAction,
  FlatFileObjectConfigFormReducerActionType,
  FlatFileObjectConfigFormReducerState
} from './interfaces';

export const FLAT_FILE_OBJECT_CONFIG_FORM_REDUCER_INITIAL_STATE: FlatFileObjectConfigFormReducerState =
  {
    inferSchemaTaskId: null,
    inferSchemaError: null,
    inferSchemaRunning: false,
    inferSchemaSuccessful: false,
    objectId: null
  };

export function FlatFileObjectConfigFormReducer(
  state: FlatFileObjectConfigFormReducerState,
  action: FlatFileObjectConfigFormReducerAction
): FlatFileObjectConfigFormReducerState {
  const { type, data } = action;

  switch (type) {
    case FlatFileObjectConfigFormReducerActionType.SAVE_INFER_SCHEMA_TASK_ID:
      return {
        ...state,
        inferSchemaTaskId: data?.inferSchemaTaskId ?? null
      };

    case FlatFileObjectConfigFormReducerActionType.INIT_INFER_SCHEMA:
      return {
        ...state,
        inferSchemaRunning: true,
        inferSchemaError: null,
        inferSchemaSuccessful: false
      };

    case FlatFileObjectConfigFormReducerActionType.SAVE_INFER_SCHEMA_SUCCESS:
      return {
        ...state,
        inferSchemaTaskId: null,
        inferSchemaRunning: false,
        inferSchemaError: null,
        inferSchemaSuccessful: true,
        objectId: data?.objectId ?? null
      };

    case FlatFileObjectConfigFormReducerActionType.SAVE_INFER_SCHEMA_ERROR:
      return {
        ...state,
        inferSchemaTaskId: null,
        inferSchemaRunning: false,
        inferSchemaSuccessful: false,
        inferSchemaError: data!.inferSchemaError as string
      };

    default:
      return state;
  }
}
